<template>
    <div class="flex-fill d-flex xscrollbar overflowX-auto overflowY-hidden bg-white" id="xscrollbarstyle-1">
        <div v-if="showLoader" class="loader1">
            <div>
                <div class="lds-ripple">
                <div></div>
                <div></div>
                </div>
            </div>
        </div>
        <div class="custom-filter-box">
            <div class="m-1 d-flex custom-input-dropdown align-items-center custom-wrap">
                <!-- <v-icon name="search"  /> -->
                <!-- <b-input class="custom-top-input" type="search" :placeholder="`Search...`" v-model="search" debounce="500"/> -->
                <!-- <b-dropdown class="m-2 custom-top-dropdown" text="Sort By">
                    <b-dropdown-item-button>Action</b-dropdown-item-button>
                    <b-dropdown-item-button>Another action</b-dropdown-item-button>
                    <b-dropdown-item-button>Something else here</b-dropdown-item-button>
                </b-dropdown> -->
                <!-- <div class="btn-group">
                    <b-button variant="outline-primary" >Filter</b-button>
                </div> -->
                <b-form-select v-model="selectedSort" class="" style="width:300px" text="Sort By" @change="checkOptionGroupClick()">
                    <b-form-select-option :value="null">Filter By</b-form-select-option>
                    <b-form-select-option :value= 0>Recent</b-form-select-option>
                    <b-form-select-option :value = 1>Oldest</b-form-select-option>
                    <b-form-select-option :value= 2>Unread</b-form-select-option>
                    <b-form-select-option :value= 3>Due Task</b-form-select-option>
                    <b-form-select-option :value= 4>Starred</b-form-select-option>
                    <b-form-select-option :value = 5>Scheduled</b-form-select-option>
                    <b-form-select-option :value = 998>Autopilot Active</b-form-select-option>
                    <b-form-select-option :value = 999>Feedback Needed</b-form-select-option>
                    <b-form-select-option :value = 1000>Past Interviews</b-form-select-option> <!-- :value = 31 -->
                    <b-form-select-option :value = 1001>Upcoming Interviews</b-form-select-option> <!-- :value = 32 -->

                    <b-form-select-option-group v-if="user.Folders" label="Folders" >
                        <b-form-select-option 
                            :key="i"
                            v-for="i in user.Folders.length" 
                            :value="5+i"
                            >{{user.Folders[i - 1]}}</b-form-select-option>
                    </b-form-select-option-group>

                    <b-form-select-option-group  label="Assessment" >
                        <!-- <b-form-select-option :value='5+user.Folders.length+1'> Priority:0</b-form-select-option> -->
                        <b-form-select-option :value='5+user.Folders.length+1'> Priority:1</b-form-select-option>
                        <b-form-select-option :value='5+user.Folders.length+2'> Priority:2</b-form-select-option>
                        <b-form-select-option :value='5+user.Folders.length+3'> Priority:3</b-form-select-option>
                    </b-form-select-option-group>
                </b-form-select>

                
                <b-button class="addNewPipeline" @click="$bvModal.show('addNewPipelineModal')">
                    Add Pipeline Stage
                </b-button>
                    
                <b-button class="addNewPipeline" @click="expiringProspects">
                    Expiring Prospects
                </b-button>

                <b-modal id="addNewPipelineModal" hide-footer>
                    <template v-slot:modal-title>
                        Add New Pipeline
                    </template>
                    <b-form @submit.stop.prevent="addNewPipeline">
                        <b-form-group label-cols="4" label="Title:" class="my-1">
                            <b-form-input
                                type="text"
                                v-model="form.newStage"
                                placeholder="Enter ..."
                                required />
                        </b-form-group>
                        <b-button type="submit" class="mt-4 mb-2" block variant="outline-primary">Submit</b-button>
                    </b-form>
                </b-modal>
                

                <!-- <b-dropdown variant="outline" toggle-class="mr-1">
                    <template v-slot:button-content>
                        <b>Apply Filter To All Prospect</b>
                    </template>
                    <b-dropdown-item-button v-if="selectedSort != 0" @click="selectedSort = 0">Recent</b-dropdown-item-button>
                    <b-dropdown-item-button v-if="selectedSort != 1" @click="selectedSort = 1">Oldest</b-dropdown-item-button>
                    <b-dropdown-item-button v-if="selectedSort != 2" @click="selectedSort = 2">Unread</b-dropdown-item-button>
                    <b-dropdown-item-button v-if="selectedSort != 3" @click="selectedSort = 3">Due Task</b-dropdown-item-button>
                    <b-dropdown-item-button v-if="selectedSort != 4" @click="selectedSort = 4">Starred</b-dropdown-item-button>
                    <b-dropdown-item-button v-if="selectedSort != 5" @click="selectedSort = 5">Scheduled</b-dropdown-item-button>
                    <hr>
                    <div v-if="user.Folders">
                        <h6 class="text-center text-blue">Folders</h6>
                        <b-dropdown-item-button
                            :key="i"
                            @click="folderClick(i)"
                            v-for="i in user.Folders.length"
                        >
                            <span v-if="selectedSort != 5 + i">{{user.Folders[i - 1]}}</span>
                        </b-dropdown-item-button>
                    </div>
                </b-dropdown> -->
            </div>
    </div> 
    
    

    
        <!-- <Stage :name="'Uncategorized'" :prosps="prospects.filter(prosp => !prosp.Status)"  @open="$emit('open', 'prosp')"/> -->
        <!-- <div v-if="this.selectedSort < 6"> -->
            <draggable v-if="this.selectedSort == 0 || this.selectedSort == 1 || this.selectedSort == 3 || this.selectedSort == 4 || this.selectedSort == 1000 || this.selectedSort == 1001 || this.selectedSort==1002 || this.selectedSort==998 || this.selectedSort==999" v-model="stages" class="flex-fill d-flex draggable-custom-stage">
                <Stage :key="stage" v-for="(stage, index) in stages" :name="stage"  :prosps="items[index]" :selectedSort=selectedSort @open="$emit('open', 'prosp')"/>
            </draggable>
        <!-- </div> -->
        <!-- <div v-if="this.selectedSort > 5 "> -->
            <!-- <draggable v-if="this.selectedSort == 2|| this.selectedSort == 5 || (this.selectedSort > 5 && this.selectedSort < 31) " v-model="stages" class="flex-fill d-flex draggable-custom-stage"> -->
            <draggable v-if="this.selectedSort == 2 || this.selectedSort == 5 || (this.selectedSort > 5 && this.selectedSort <= this.selectedSort) " v-model="stages" class="flex-fill d-flex draggable-custom-stage">
                <Stage :key="stage" v-for="(stage, index) in stages" :name="stage" :prosps="filterdItems[index]" :selectedSort=selectedSort @open="$emit('open', 'prosp')"/>
            </draggable>
        <!-- </div> -->
        <!-- <div style="margin-top:65px !important">
            <Stage :name="'Archived'" :prosps="prospects.filter(prosp => prosp.Status == 'Archived')"  @open="$emit('open', 'prosp')"/>
        </div> -->

        <b-modal id="expiringDataModal" hide-footer size="xl">
            <div>
                
            <download-csv v-if="this.expiringProspect.length > 0"
                style="margin-left: 10px;"
                :data="this.getCSVData()"
                :name="this.getFileName()"
                :fields="fields"
                :labels="labels"
                >
                <b-button class="addNewPipeline expo">Export</b-button>
            </download-csv>
            <p>Prospects with text message conversations older than 1 year appear below. These prospects and their conversations will be deleted on their respective Removal Dates unless you send them a new text message. Relevant reporting data will be preserved to ensure historical accuracy of reporting. This list is updated every 24 hours, so updates may not be shown right away period</p>
            </div>
            <div class="rounded border bg-white m-3 text-center overflow-auto module2">
            <h5 class="border-bottom py-2 mb-2">Expiring Prospects</h5>
            <b-table-simple bordered striped hover class="w-100 mx-auto text-left">
                <b-thead head-variant="light">
                    <b-tr class="text-center">
                        <b-th>Removal Date</b-th>
                        <b-th>First</b-th>
                        <b-th>Last</b-th>
                        <b-th>Number</b-th>
                        <b-th>Email</b-th>
                        <b-th>Status</b-th>
                        <b-th @click.stop="emitToProspInfo(expiring)"></b-th>
                    </b-tr>
                </b-thead>
                <b-tbody v-if="expiringProspect">
                    <b-tr 
                        :key="expiring.name"
                        v-for="expiring in expiringProspect"
                        class="text-left position-relative pointer" 
                        @click="emitToProspInfo(expiring)"
                    >
                        <b-td v-if="expiring.ExpiringDate">{{removeDate(expiring.ExpiringDate)}}</b-td>
                        <b-td>{{expiring.First}}</b-td>
                        <b-td>{{expiring.Last}}</b-td>
                        <b-td>{{expiring.Number}}</b-td>
                        <b-td>{{expiring.Email}}</b-td>
                        <b-td>{{expiring.Status}}</b-td>
                        <b-td @click.stop>
                        <b-button class="addNewPipeline" @click="keepOrDeleteRecord('keep',expiring)">Keep</b-button>
                        <b-button class="addNewPipeline" @click="keepOrDeleteRecord('delete',expiring)">Delete</b-button>
                        </b-td>
                    </b-tr>
                </b-tbody>
                <!-- <div v-else>
                <h1>No data found</h1>
                </div> -->
            </b-table-simple>
            </div>
            
        </b-modal>
        
    </div>
</template>

<script>
    import Stage from './subcomponents/Stage'
    import draggable from 'vuedraggable'
    import { mapState } from 'vuex'
    import { db } from 'src/db'
    import moment from 'moment';

    export default {
        name: "Pipeline",
        components: {
            draggable,
            Stage
        },
        created(){
            this.$store.dispatch('firebase/rebindConvosUnreadCount', {
                uid: this.user.Uid,
                id: this.user.id,
            })
        },
        // asyncComputed
        computed: {
            dragOptions() {
                return {
                    animation: 0,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            stages: {
                get() {
                    let stages = [];
                    stages = this.$store.state.firebase.user.Stages;
                    if (stages.indexOf("Archived") < 0) {
                        stages.push("Archived");
                    }
                    return stages;
                    // return this.$store.state.firebase.user.Stages
                },
                set(value) {
                    db.doc(`Users/${this.user.id}`).update({Stages: value});
                }
            },
            items() {
                let ret = [];
                this.stages.forEach(() => {
                    ret.push([]);
                });
                let filterProspArray = this.prospects;
                // let filterConvoArray = this.convos;
                if (this.selectedSort == 0) {    
                    // filterProspArray.sort((a, b) => b.DateCreated - a.DateCreated);
                }else if (this.selectedSort == 1) {
                    filterProspArray.sort((a, b) => a.DateCreated - b.DateCreated);
                }
                // else if (this.selectedSort == 2) {
                //  filterProspArray.sort((a, b) => b.DateCreated - a.DateCreated);
                // }
                else if (this.selectedSort == 3) {
                    filterProspArray =  this.sortByDueTask(filterProspArray)
                }
                else if (this.selectedSort == 4) {
                    filterProspArray =  this.sortByStarred(filterProspArray);
                } else if (this.selectedSort == 1000) {
                    filterProspArray = this.PastInterviews(filterProspArray);
                } else if (this.selectedSort == 1001) {
                    filterProspArray = this.UpcomingInterviews(filterProspArray);
                }else if (this.selectedSort == 998) {
                    filterProspArray = this.cachedAutoPilotData || [];
                }else if (this.selectedSort == 999) {
                    filterProspArray = this.cathedFeedbackData || [];
                }
                // else if (this.selectedSort == 5) {
                //  filterProspArray.sort((a, b) => b.DateCreated - a.DateCreated);
                // }
                // else {
                //  filterProspArray  =  this.sortyByFolders(filterProspArray);
                // }

                filterProspArray && filterProspArray.length > 0 && filterProspArray.forEach(prosp => {
                    if (!prosp.Status) {
                        prosp.Status = 'New'
                    }
                    let index = this.stages.indexOf(prosp.Status);
                    if (index != -1) {
                        ret[index].push(prosp);
                    }
                });
                return ret;
            },
            convo() {
                if (!this.activeConvo) {
                    return null;
                }
                return this.convos.find(convo => convo.id == this.activeConvo);
            },
            prosp() {
                if (!this.activeProsp) {
                    return null;
                }
                return this.prospects.find(prosp => prosp.id == this.activeProsp);
            },
            ...mapState('firebase', ['user', 'prospects', 'convos','activeConvo','activeProsp','emails','calls'])
        },
        methods: {
            removeDate(rdate){
                return moment(rdate).format('M/DD/YYYY');
            },
            async emitToProspInfo(prop) {

                let convoSnap = await db.collection('Conversations')
					.where('ClientNumber', '==', prop.Number)
					.where('Uid', '==', this.user.Uid)
					.orderBy('DateUpdated', 'desc')
					.get();
					let convoData = convoSnap.docs.map(doc => ({
										id: doc.id, 
										...doc.data(),
									}));
				// eslint-disable-next-line
				console.log('convoSnap', convoData);
				// eslint-disable-next-line
				console.log('convos', this.convos);

                let newConvo = convoData[0];
                if (newConvo && !this.convos.some(convo => convo.id === newConvo.id)) {
				var newN = [...this.convos,newConvo];
				this.$store.commit('firebase/SET', { var: 'convos', val: newN });
				}
                
                let convo = this.convos.find(convo => convo.ClientNumber == prop.Number); 
                if(convo){
                this.$store.commit('globals/SET', { var: 'activeConvo', val: convo.id });
                this.$store.dispatch('firebase/bindMessages', convo.id);
                }else{
                    this.$store.commit('globals/SET', { var: 'activeConvo', val: null });
                    this.$store.dispatch('firebase/bindMessages', null);
                }
                if (this.emails && this.emails.length) {
                    let mid = this.getEmailConvoID(prop.id);
                    if (mid) {
                        this.$store.dispatch('firebase/bindMails', mid);
                    }else {
                        this.$store.dispatch('firebase/clearonlyMailsData');
                    }
                }
                if(this.calls != null && this.calls.length){
					let cid = this.getCallsConvoID(prop.id);
					if (cid){
						this.$store.dispatch('firebase/bindPhones', cid);
					}else {
						this.$store.dispatch('firebase/clearonlyPhonesData');
				}
				}
                this.$store.commit('globals/SET', { var: 'activeProsp', val: prop.id });
                this.$emit('open','prosp');
            },
            getCallsConvoID(prospId) {
				let phoneid = '';
				let phone = this.calls.find(e => e.Uid == this.user.Uid && e.ProspectID == prospId);
				if (phone) {
					phoneid = phone.id;
				}
				return phoneid;
			},
            getCSVData() {
                let csvDataJson = this.expiringProspect;
                if (this.downloadCount == 0) {
                    this.downloadCount = this.downloadCount+1;
                    csvDataJson.sort((a, b) => b.DateCreated - a.DateCreated);
                    csvDataJson.forEach(element => {
                        let dc = this.$parsePlainDate(element.DateCreated) + '-' + this.$parsePlainTime(element.DateCreated);
                        element['DuplicateDateCreated'] = dc;
                        element['DuplicateFirst']=element.First;
                        element['DuplicateLast']=element.Last;
                    })
                }
                return csvDataJson;
            },
            getEmailConvoID(prospId) {
                let mailid = '';
                let mail = this.emails.find(e => e.Uid == this.user.Uid && e.ProspectID == prospId);
                if (mail) {
                    mailid = mail.id;
                }
                return mailid;
            },
            expiringProspects(){
                this.$bvModal.show('expiringDataModal');
                this.expiringProspect=this.expiringProspectsData(this.prospects);
            },
            async keepOrDeleteRecord(action,data){
                if(action === 'keep'){
                    //eslint-disable-next-line
                    console.log('keep selected',data);
                    if(confirm('Send this prospect a new text message in order to retain their conversation and prospect data.')){
                        this.emitToProspInfo(data);
                        // this.$emit('open','prosp');
                    }
                }
                if(action === 'delete'){
                    let convo = this.$store.state.firebase.convos.find(convo => convo.ClientNumber == data.Number);
                    //eslint-disable-next-line
                    console.log('delete',convo);
                    if(confirm('Deleting this prospect will permanently remove all conversation and prospect data. Are you sure you want to continue?')){
                        // delete conversation and their emails and calls data
                        if(convo) {
                            db.doc(`Conversations/${convo.id}`).delete();
                        }
                        const cnvref = await db.collection('Emails').where('ProspectID', '==', data.id).get();
                        cnvref.docs.forEach(doc => {
                            doc.ref.delete();
                        });
                        const cnvrefCall = await db.collection('Calls').where('ProspectID', '==', data.id).get();
                        cnvrefCall.docs.forEach(doc => {
                            doc.ref.delete();
                        });
                        this.$bvModal.hide('expiringDataModal');
                    }
                }
            },
            getFileName() {
                return  this.user.Company+'-'+this.$parsePlainDate(new Date().getTime())+'-expiring_prospects.csv';
            },
            addNewPipeline() {
                let stageArray1 = this.user.Stages; // OLD STAGES
                var convertCurrentStagesToUppercase = String(this.user.Stages).toUpperCase().split(","); // CONVERT ALL STAGES UPPER CASE
                var currentStageToUppercase = this.form.newStage.toUpperCase(); // CONVERT CURRENT STAGE UPPER CASE
                if(this.form.newStage) { // CHECK VALUE BLANK OR NOT
                    var check = convertCurrentStagesToUppercase.includes(currentStageToUppercase);
                    if(!check) { // IF VALUE IS NOT EXIST, PUSH IN ARRAY (true,false)
                        stageArray1.unshift(this.form.newStage);
                        db.doc(`Users/${this.user.id}`).update({Stages:stageArray1});
                        alert('Added Successfully');
                        this.form.newStage = '';
                        this.$bvModal.hide('addNewPipelineModal');
                    }
                }
            },
            // async folderClick(i) {
            //  this.selectedSort = 5 + i
            //  // this.showLoader = true;
            //  if (this.selectedSort > 5) {
            //      let ret = [];
            //      this.stages.forEach(() => {
            //          ret.push([]);
            //      });
            //      let iFolder = this.selectedSort-6;
            //      let val = this.user.Folders[iFolder];
            //      let colRef = await db.collection(`Users/${this.user.id}/Prospects`).where('Tags', 'array-contains', val).get();
            //      let prospectList = colRef.docs.map((doc) => {
            //          let data = { id: doc.id, ...doc.data() };
            //          return data;
            //      })
            //      prospectList.forEach(prosp => {
            //          if (!prosp.Status) {
            //              prosp.Status = 'New'
            //          }
            //          let index = this.stages.indexOf(prosp.Status);
            //          if (index != -1) {
            //              ret[index].push(prosp);
            //          }
            //      });
            //      // this.showLoader = false;
            //      this.filterdItems = ret;
            //  }
            // },

            async checkOptionGroupClick() {
                if (this.selectedSort == 2) {
                    let convoSnap = await db.collection('Conversations')
					.where('Uid', '==', this.user.Uid)
                    .where("Unread", ">", 0)
					.orderBy("Unread", "desc")
					.orderBy('DateUpdated', 'desc')
					.get();
                    let cnv = convoSnap.docs.map(doc => ({
                                    id: doc.id, 
                                    ...doc.data(),
                                }));
                    this.$store.commit("firebase/SET", {
						var: "convos",
						val: cnv,
					});
                    // let cnv = this.convos.filter(convo => convo.Unread);
                    let unreadProsp = [];
                    for (let cn of cnv) {
                        let pr = this.prospects.find(p => p.Number == cn.ClientNumber);
                        if (pr) {
                            unreadProsp.push(pr);
                        }
                    }
                    let ret = [];
                    this.stages.forEach(() => {
                        ret.push([]);
                    });
                    unreadProsp.forEach(prosp => {
                        if (!prosp.Status) {
                            prosp.Status = 'New'
                        }
                        let index = this.stages.indexOf(prosp.Status);
                        if (index != -1) {
                            ret[index].push(prosp);
                        }
                    });

                    this.filterdItems = ret;
                }
                if (this.selectedSort == 5) {
                    let convoSnap = await db.collection('Conversations')
					.where('Uid', '==', this.user.Uid)
                    .where('ScheduledCount', '>', 0)
                    .orderBy('ScheduledCount', 'desc')
					.orderBy('DateUpdated', 'desc')
					.get();
                    let cnv = convoSnap.docs.map(doc => ({
                            id: doc.id, 
                            ...doc.data(),
                        }));
                    
                    if(cnv && cnv.length > 0){
                    let ret = [];
                    this.stages.forEach(() => {
                        ret.push([]);
                    });
                    let scheduledConvos = [];
                    //eslint-disable-next-line
				    console.log("cnv cnv:", cnv);

                    this.$store.commit("firebase/SET", {
						var: "convos",
						val: cnv,
					});

                    for (let c of cnv) {
                        if (c.hasOwnProperty('ScheduledCount') && c.ScheduledCount) {
                            // scheduledConvos.push(convo)
                            let p = this.prospects.find(p => p.Number == c.ClientNumber);
                            if (p){
                                scheduledConvos.push(p)
                            }
                        }
                    }
                    scheduledConvos.forEach(prosp => {
                        if (!prosp.Status) {
                            prosp.Status = 'New'
                        }
                        let index = this.stages.indexOf(prosp.Status);
                        if (index != -1) {
                            ret[index].push(prosp);
                        }
                    });
                    
                    this.filterdItems = ret;
                }
                }
                if (this.selectedSort > 5 && this.selectedSort < (this.user.Folders.length+6)) {
                    let ret = [];
                    this.stages.forEach(() => {
                        ret.push([]);
                    });
                    let iFolder = this.selectedSort-6;
                    let val = this.user.Folders[iFolder];
                    let colRef = await db.collection(`Users/${this.user.id}/Prospects`).where('Tags', 'array-contains', val).get();
                    let prospectList = colRef.docs.map((doc) => {
                        let data = { id: doc.id, ...doc.data() };
                        return data;
                    })
                    let colRef1 = await db.collection(`Users/${this.user.id}/Prospects`).where('Tags', '==', val).get();
                    let prospectList1 = colRef1.docs.map((doc) => {
                        let data = { id: doc.id, ...doc.data() };
                        return data;
                    })
                    prospectList = prospectList.concat(prospectList1);
                    prospectList.forEach(prosp => {
                        if (!prosp.Status) {
                            prosp.Status = 'New'
                        }
                        let index = this.stages.indexOf(prosp.Status);
                        if (index != -1) {
                            ret[index].push(prosp);
                        }
                    });
                    this.filterdItems = ret;
                }
                if (this.selectedSort >= (this.user.Folders.length+6)) {
                    let ret = [];
                    this.stages.forEach(() => {
                        ret.push([]);
                    });

                    // let p = this.selectedSort-(this.user.Folders.length+6)+0;
                    let p = this.selectedSort-(this.user.Folders.length+6)+1;

                    let colRef = await db.collection(`Users/${this.user.id}/Prospects`).where('CciMap.Priority', '==', p).get();
                    let prospectList = colRef.docs.map((doc) => {
                        let data = { id: doc.id, ...doc.data()};
                        return data;
                    });
                    prospectList.forEach(prosp => {
                        if (!prosp.Status) {
                            prosp.Status = 'New'
                        }
                        let index = this.stages.indexOf(prosp.Status);
                        if (index != -1) {
                            ret[index].push(prosp);
                        }
                    });
                    this.filterdItems = ret;
                }
            },
            // Past Interviews FILTER DATA
            PastInterviews(items) {
                let PastInterviewsData = [];
                for (let item of items) {
                    if (item && item.Interviewed <= this.todaysDate && item.Interviewed) {
                        PastInterviewsData.push(item)
                    }
                }
                return PastInterviewsData
            },
            // Upcoming Interviews FILTER DATA
            UpcomingInterviews(items) {
                let UpcomingInterviewsData = [];
                for (let item of items) {
                    if (item && item.Interviewed >= this.todaysDate && item.Interviewed) {
                        UpcomingInterviewsData.push(item)
                    }
                }
                return UpcomingInterviewsData
            },
            // Expiring Prospects FILTER DATA
            expiringProspectsData(items) {
                let eData = [];
                for (let item of items) {
                    if (item && item.Expiring) {
                        eData.push(item)
                    }
                }
                return eData
            },
            // Autopilot FILTER DATA
            async autopilotData() {
                let convoSnap = await db.collection('Conversations')
					.where('Uid', '==', this.user.Uid)
                    .where('autoSms', '==', true)
                    .orderBy('autoSms', 'desc')
					.orderBy('DateUpdated', 'desc')
					.get();
                let convoData = convoSnap.docs.map(doc => ({
                                    id: doc.id, 
                                    ...doc.data(),
                                }));
                let aData = [];
                for (let item of convoData) {
                    if (item && item.autoSms) {
                        aData.push(item)
                    }
                }
                let filteredProspects = this.prospects.filter(p => 
                    aData.some(a => a.ClientNumber === p.Number)
                );
                this.cachedAutoPilotData = filteredProspects;

                // return filteredProspects
            },
            // Human feedback needed FILTER DATA
            async feedbackNeededData() {
                let convoSnap = await db.collection('Conversations')
					.where('Uid', '==', this.user.Uid)
                    .where("needHumanFeedback", "==", true)
					.orderBy("needHumanFeedback", "desc")
					.orderBy('DateUpdated', 'desc')
					.get();
                let convoData = convoSnap.docs.map(doc => ({
                                    id: doc.id, 
                                    ...doc.data(),
                                }));
                let aData = [];
                for (let item of convoData) {
                    if (item && item.needHumanFeedback) {
                        aData.push(item)
                    }
                }
                let filteredProspects = this.prospects.filter(p => 
                    aData.some(a => a.ClientNumber === p.Number)
                );

                this.cathedFeedbackData = filteredProspects;
                // return filteredProspects
            },
            sortByStarred(items) {
                let starredProsp = [];
                for (let item of items) {
                    if (item && item.hasOwnProperty('Starred') && item.Starred) {
                        starredProsp.push(item)
                    }
                }
                return starredProsp
            },
            sortByDueTask(items) {
                let dueProps = [];
                for (let item of items) {
                    if (this.isOverDue(item)) {
                        dueProps.push(item)
                    }
                }
                return dueProps
            },
            isOverDue(findProps) {
                let val = false;
                if(findProps && findProps.Tasks) {
                    for (let task of findProps.Tasks) {
                        if (task.DueOn && task.Status == 'draft' && (task.DueOn <= Date.now() || this.isToday(new Date(task.DueOn)))) {
                            val = true;
                            break   
                        }
                    }
                    
                }
                return val
            },
            isToday(date) {
                const today = new Date()
                return date.getDate() === today.getDate() &&
                    date.getMonth() === today.getMonth() &&
                    date.getFullYear() === today.getFullYear();
            },
            sortyByFolders(items) {
                let folderProps = [];
                if (this.selectedSort == null) {
                    return items.sort((a, b) => b.DateCreated - a.DateCreated);
                }else {
                    let iFolder = this.selectedSort-6;
                    for (let item of items) {
                        if (item.Tags.includes(this.user.Folders[iFolder])) {
                            folderProps.push(item)
                        }
                    }
                    return folderProps
                }
                
            },
            async filterFromFirebase(val) {
                let colRef = await db.collection(`Users/${this.user.id}/Prospects`).where('Tags', 'array-contains', val).get();
                
                let prospectList = colRef.docs.map((doc) => {
                    let data = { id: doc.id, ...doc.data() };
                    return data;
                })
                let abc = [];
                var promise = Promise.resolve(prospectList)
                await promise.then(function(val) {
                    abc = val;
                });
                return abc;
            }
        },
        data() {
            return {
                selectedSort:0,
                filterdItems:[],
                showLoader:false,
                todaysDate:new Date().valueOf(),

                form: {
                    newStage: '',
                },
                expiringProspect:[],
                downloadCount:0,
                fields:['DuplicateDateCreated','DuplicateFirst','DuplicateLast','Email','Number','Zip','Status','Source','Tags'],
                labels:{
                    DuplicateDateCreated: 'Date Created',
                    DuplicateFirst: 'First Name',
                    DuplicateLast: 'Last Name',
                    Number: 'Phone Number',
                    Zip:'Postal Code'
                },
                cachedAutoPilotData:[],
                cathedFeedbackData:[],
                // user:{},
                // stages:[],
                // prospects:[]
            }
        },

        watch:{
            selectedSort(newValue) {
                if(newValue === 998){
                    this.autopilotData();
                }
                if(newValue === 999){
                    this.feedbackNeededData();
                }
            }
        }
    }
</script>

<style scoped>
.addNewPipeline, .addNewPipeline:hover, .addNewPipeline:focus, .addNewPipeline:active{
    margin-left: 10px;
    font-size: 12px;
    border-radius: 3px;
    background: #007bff!important;
    border: 1px solid #007bff!important;
    outline: none;
    box-shadow: none;
}

.custom-input-dropdown svg path{
    fill: #042b79 !important;
}

.custom-input-dropdown svg.fa-icon {
    position: absolute;
    margin-left: 10px;
}

.custom-input-dropdown input {
    padding-left: 32px;width: 300px;
}
.custom-top-input {
    padding-left: 30px;
    border-color: #6c757d;
}
.custom-filter-box {
    position: absolute;
    margin-left: 4px;
    width: 100%;
    padding: 6px 30px 0px;
    text-align: center;
    width: 100%;
    display: flex;
}

.flex-fill.d-flex.draggable-custom-stage {
    padding-top: 60px;
}
.custom-filter-box {
    position: absolute;
    margin-left: 4px;
    width: 100%;
    padding-top: 12px;
}
.btn-group button.btn.btn-outline-primary {
    background: #042b79;
    color: #fff;
    border-color: #042b79;width: 300px;
}
.custom-top-dropdown {
    margin: 6px 30px !important;
    width: 300px;
}
::-webkit-scrollbar {
    width: 5px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1; height:5px;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
.headSectionP{
    margin: 0;
    font-weight: normal;
    font-size: 16px;
    color: #898989;
}

.bodySection .row{
    padding: 0px 10px;
}

.bodySection .col-md-5, .bodySection .col-md-2{
    padding: 0px 5px;   
}
.expo{
    float: right;
    margin-right: 15px;
    width: 5rem;
    margin-top: 5px;
}
</style>
<style>
.modal-content{
    border-radius: 0px!important;
}
</style>
